export default class UpdateUserDto {
  public username: string;
  public password: string;
  public email: string;
  public role: string;

  constructor(data: {
    username: string;
    password: string;
    email: string;
    role: string;
    trackingId: string;
  }) {
    this.username = data.username;
    this.password = data.password;
    this.email = data.email;
    this.role = data.role;
  }
}
